module.exports = __webpack_public_path__ + "img/cb9-l-001.1037c98e.gif";